import { routes } from "@/root";
import type React from "react";
import { Navigate } from "react-router";

export const Dashboard: React.FC = () => {
  return <Navigate to={routes.controls.path} replace />;
  /*return (
    <div className="flex flex-col">
      <div className="flex justify-between mb-6 items-end align-bottom">
        <Typography variant="h5" className="self-center">
          {t("dashboard")}
        </Typography>
      </div>
    </div>
  );*/
};

export default Dashboard;
